// src/Perfil/Autenticacion/GoogleCallback.jsx o donde lo tengas

import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios'; // Importa axios
import { useToast } from '@chakra-ui/react'; // O tu sistema de notificaciones

// Ajusta estas rutas según tu estructura de proyecto real
import { setAuthInfo } from '../../Redux/Slice'; // TU NUEVA ACCIÓN para guardar token y user
import { setAuthToken } from '../../Redux/Slice'; // La función exportada para configurar axios/localStorage

// Asegúrate que API_BASE esté disponible, igual que en tu Slice.jsx
const API_BASE = process.env.REACT_APP_API_BASE;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useToast(); // Para mostrar mensajes de error
  const hasRun = useRef(false); // Para evitar doble ejecución en StrictMode

  useEffect(() => {
    // Evita doble ejecución en React StrictMode (desarrollo)
    if (hasRun.current) return;
    hasRun.current = true;

    const params = new URLSearchParams(location.search);
    // El nombre del parámetro 'token' debe coincidir con el que pusiste en el backend
    const token = params.get('token');

    const handleAuth = async () => {
      if (token) {
        console.log("Token recibido del backend:", token);

        try {
          // 1. Configura Axios y guarda el token en localStorage
          setAuthToken(token);

          // 2. Obtiene los datos del usuario desde el backend usando el token
          console.log(`Workspaceing user data from: ${API_BASE}/api/users/me?populate=role`);
          const userResponse = await axios.get(
            `${API_BASE}/api/users/me?populate=role` // Añade 'populate' si necesitas el rol u otros datos
          );
          const user = userResponse.data;
          console.log("User data fetched:", user);

          if (!user) {
            throw new Error("No se pudieron obtener los datos del usuario desde el backend.");
          }

          // 3. Guarda el token y los datos del usuario en el estado de Redux
          dispatch(setAuthInfo({ token, user }));
          console.log("Redux state updated with token and user info.");

          // 4. Redirige al usuario a la página principal o dashboard
          // Podrías añadir lógica aquí para redirigir a /PersonalData si faltan datos
          if (!user.username || !user.email || !user.direccion || !user.telefono) {
            console.log("Usuario necesita completar datos. Redirigiendo a /PersonalData");
            navigate('/PersonalData', { replace: true });
          } else {
            console.log("Usuario completo. Redirigiendo a /");
            navigate('/', { replace: true }); // O '/dashboard'
          }

        } catch (error) {
          console.error("Error durante el procesamiento del callback de Google:", error);
          // Limpia el token si algo falló después de setearlo
          setAuthToken(null);
          toast({
            title: "Error de autenticación",
            description: `No se pudo completar el inicio de sesión: ${error.message || 'Error desconocido'}`,
            status: "error",
            duration: 7000,
            isClosable: true,
          });
          navigate('/Login', { replace: true }); // Redirige a login con error
        }

      } else {
        console.error("No se recibió token en el callback del frontend.");
        toast({
          title: "Error",
          description: "No se recibió el token de autenticación desde el servidor.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        navigate('/Login', { replace: true }); // Redirige a login con error
      }
    };

    handleAuth();

  // Asegúrate de incluir todas las dependencias externas que uses dentro del useEffect
  }, [location, navigate, dispatch, toast]);

  // Muestra un mensaje o spinner mientras se procesa
  return <div>Procesando autenticación...</div>;
};

export default AuthCallback;